import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { SearchOff } from '@mui/icons-material';

export default function NotFoundPage() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', textAlign: 'center', px: 2 }}>
      <SearchOff sx={{ fontSize: 80, color: 'text.disabled', mb: 2 }} />
      <Typography variant="h3" fontWeight={800} letterSpacing="-1px" gutterBottom>404</Typography>
      <Typography variant="h6" color="text.secondary" gutterBottom>Page not found</Typography>
      <Typography color="text.disabled" sx={{ mb: 4 }}>
        The page you're looking for doesn't exist or has been moved.
      </Typography>
      <Button component={Link} to="/" variant="contained" size="large" sx={{ borderRadius: '10px', fontWeight: 700, px: 4 }}>
        Go Home
      </Button>
    </Box>
  );
}
